import { RefObject, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { View } from '@/components/Themed';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import { CustomText } from '@/components/CustomText';
import { Button } from 'react95-native-rabbl';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setLoggedIn } from '@/state/user';
import { updateVisuals } from '@/state/uploads';
import { useRouter, Link, useLocalSearchParams } from 'expo-router';
import Footer from '@/components/Footer';
import Profile from '@/components/Profile';
import { AppContext } from '@/components/AppContext';
import { CommunityMembership } from "@/types/community_membership";
import { setData } from '@/state/user';
import { useBottomTabBarHeight } from "expo-router/js-tabs";
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
});

export default function MyProfile() {
  const communityMembership = useSelector((state: RootState) => state.user.communityMembership);
  const tabBarHeight = useBottomTabBarHeight();

  return (
    <BasicScrollView center={true}>
      <Meta title={"Profile"} />
      <Profile
        member={communityMembership}
        bottomPadding={false}
        extraOffsetHeight={tabBarHeight}
        edit={true}
      />
      <View style={{ marginTop: 20, flexDirection: "row", flexWrap: "wrap", gap: 20, backgroundColor: "transparent" }}>
        <Link href="/settings" asChild={true} className={"nontext"}><Button>Make changes</Button></Link>
      </View>
      <Footer />
    </BasicScrollView>
  );
}
